import { CalBadge, EventIcon } from "./EventCard";

const when = (n) => (n === 1 ? "Mañana" : n < 7 ? `En ${n} días` : null);

export function UpcomingList({ items }) {
  if (!items.length) return <p className="text-sm italic text-cocoa-soft">Nada en los próximos dos meses.</p>;
  const byDate = items.reduce((acc, it) => { (acc[it.date] = acc[it.date] || []).push(it); return acc; }, {});
  return (
    <ol className="relative border-l border-line ml-3 space-y-5" data-testid="cal-upcoming-list">
      {Object.entries(byDate).map(([date, list]) => (
        <li key={date} className="pl-5 relative" data-testid={`cal-upcoming-${date}`}>
          <span className="absolute -left-[5px] top-1.5 w-2.5 h-2.5 rounded-full bg-amber-deep ring-4 ring-paper" />
          <p className="text-xs text-cocoa-soft mb-1.5">
            {when(list[0].days_until) && <span className="font-semibold text-amber-deep mr-1.5">{when(list[0].days_until)} ·</span>}
            <span className="first-letter:uppercase inline-block">{list[0].date_label}</span>
          </p>
          <div className="space-y-2">
            {list.map((ev, i) => (
              <div key={i} className="flex items-start gap-3 rounded-2xl bg-cream border border-line px-4 py-3">
                <span className={`mt-0.5 ${ev.kind === "fiesta" || ev.kind === "yahrzeit" ? "text-dusk" : "text-amber-deep"}`}><EventIcon ev={ev} className="w-4 h-4" /></span>
                <div className="min-w-0 flex-1">
                  <p className="text-sm font-medium text-cocoa leading-snug">{ev.title}</p>
                  <div className="mt-1 flex flex-wrap items-center gap-2">
                    {ev.kind === "fiesta" ? <span className="text-xs text-cocoa-soft">{ev.detail}</span> : <CalBadge calendar={ev.calendar} />}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </li>
      ))}
    </ol>
  );
}
